__turbopack_context__.v({
  "arrow": "Select-module-scss-module__f1Ykqa__arrow",
  "disabled": "Select-module-scss-module__f1Ykqa__disabled",
  "error": "Select-module-scss-module__f1Ykqa__error",
  "fullWidth": "Select-module-scss-module__f1Ykqa__fullWidth",
  "hasError": "Select-module-scss-module__f1Ykqa__hasError",
  "helperText": "Select-module-scss-module__f1Ykqa__helperText",
  "isPlaceholder": "Select-module-scss-module__f1Ykqa__isPlaceholder",
  "label": "Select-module-scss-module__f1Ykqa__label",
  "required": "Select-module-scss-module__f1Ykqa__required",
  "secondary": "Select-module-scss-module__f1Ykqa__secondary",
  "select": "Select-module-scss-module__f1Ykqa__select",
  "selectWrapper": "Select-module-scss-module__f1Ykqa__selectWrapper",
  "wrapper": "Select-module-scss-module__f1Ykqa__wrapper",
});
